import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { SVGIconComponent } from '@progress/kendo-angular-icons';
import { SVGIcon, xIcon } from '@progress/kendo-svg-icons';
import { User } from '../../../../features/user/services/user.service';
import { PrimaryButtonComponent } from '../../../ui/buttons/primary-button/primary-button.component';
import { SecondaryButtonComponent } from '../../../ui/buttons/secondary-button/secondary-button.component';
import { PasswordFieldComponent } from '../../password-field/password-field.component';

@Component({
  selector: 'app-user-change-password-modal',
  templateUrl: './user-change-password-modal.component.html',
  styleUrls: ['./user-change-password-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SVGIconComponent,
    PasswordFieldComponent,
    SecondaryButtonComponent,
    PrimaryButtonComponent,
  ],
})
export class UserChangePasswordModalComponent implements OnChanges {
  private cdr = inject(ChangeDetectorRef);

  @Input() visible = false;
  @Input() selectedUser: User | null = null;

  @Output() saveClicked = new EventEmitter<{ userId: string; newPassword: string }>();
  @Output() cancelClicked = new EventEmitter<void>();

  @ViewChild(PasswordFieldComponent) passwordField?: PasswordFieldComponent;

  errorMessage = '';
  xIconSvg: SVGIcon = xIcon;
  isPasswordValid = false;

  onSave(event: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.selectedUser || !this.passwordField) {
      this.errorMessage = 'User or password field not available';
      this.cdr.markForCheck();
      return;
    }

    if (!this.isPasswordValid) {
      this.errorMessage =
        'Password is not valid. Please ensure the password meets the requirements.';
      this.cdr.markForCheck();
      return;
    }

    const password = this.passwordField.getPassword();
    if (!password) {
      this.errorMessage = 'Password is required';
      this.cdr.markForCheck();
      return;
    }

    this.errorMessage = '';
    this.cdr.markForCheck();
    this.saveClicked.emit({
      userId: this.selectedUser.userId,
      newPassword: password,
    });
  }

  onCancel(): void {
    this.passwordField?.reset();
    this.errorMessage = '';
    this.isPasswordValid = false;
    this.cancelClicked.emit();
  }

  onPasswordValidityChange(isValid: boolean): void {
    this.isPasswordValid = isValid;
    this.cdr.markForCheck();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && changes['visible'].currentValue && this.selectedUser) {
      // Use setTimeout to ensure ViewChild is available
      setTimeout(() => {
        this.passwordField?.reset();
        this.errorMessage = '';
        this.isPasswordValid = false;
        this.cdr.markForCheck();
      }, 0);
    }
  }
}
